import React,{useEffect} from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './components/Login/Login';
import Sidebar from './components/Sidebar/Sidebar';
import Dashboard from './components/Dashboard/Dashboard';
import Managelead from './components/Leads/Manageleads';
import Addlead from './components/Leads/Addlead';
import Distribution from './components/Distribution/Distribution';
import { LoginProvider } from './components/Login/LoginContext';
import Dasboard_user from './components/Dashboard/Dashboard_user';
import Apk from './components/APK/Apk';
import  Leadtran from './components/Distribution/Leadtran';
import Lead_head  from './components/Distribution/Lead_head';
import Sharecreate from './components/Share/Sharecreate'
import Demokey from './components/Share/Demokey';
import Reportsview from './components/Reports/Reportsview';
import Onlineorder from './components/Onlineorder/Order';
import Onlineorder1 from './components/Onlineorder/Order1';
import Reportable from './components/Reports/Reportable';
import Autosend from './components/Autosendmessage/Autosend';
import Bulkwhatsappsender from './components/Bulkwhatsappsender/Bulkwhatsapp';
import Error from './components/404/Error';
import Training from './components/Training/Training';
function App() {
  useEffect(() => {
    const disableRightClick = (event) => {
      event.preventDefault();
    };

    const disableF12 = (event) => {
      const key = event.key.toLowerCase();  // Convert the key to lowercase to ensure case-insensitive comparison

      if (
        key === "f12" ||  // F12: Opens Developer Tools in most browsers
        //  (event.ctrlKey && event.shiftKey && key === "i") ||  // Ctrl+Shift+I: Opens the Developer Tools with the Inspect Element tool active
        (event.ctrlKey && event.shiftKey && key === "c") ||  // Ctrl+Shift+C: Opens Developer Tools with the Inspect Element mode active (similar to Ctrl+Shift+I)
        (event.ctrlKey && event.shiftKey && key === "j") ||  // Ctrl+Shift+J: Opens the JavaScript console
        (event.ctrlKey && event.shiftKey && key === "k") ||  // Ctrl+Shift+K: Opens the JavaScript console in Firefox
        (event.ctrlKey && event.shiftKey && key === "s") ||  // Ctrl+Shift+S: Opens Developer Tools with the Debugger tool active in some browsers
        (event.ctrlKey && event.shiftKey && key === "e") ||  // Ctrl+Shift+E: Opens the Network tab in Developer Tools in Firefox
        (event.ctrlKey && event.shiftKey && key === "p") ||  // Ctrl+Shift+P: Opens the command menu in Chrome DevTools
        (event.ctrlKey && event.shiftKey && key === "m") ||  // Ctrl+Shift+M: Toggles the device toolbar (mobile view) in Chrome DevTools
        (event.ctrlKey && key === "u") ||  // Ctrl+U: Opens the View Page Source window
        (event.ctrlKey && key === "f8") ||  // Ctrl+F8: Pauses script execution in some browsers
        (event.ctrlKey && key === "f9") ||  // Ctrl+F9: Opens the Sources tab in Chrome DevTools
        (event.ctrlKey && key === "f10") ||  // Ctrl+F10: Steps over the next function call in the JavaScript debugger
        (event.ctrlKey && key === "f11")  // Ctrl+F11: Steps into the next function call in the JavaScript debugger
      ) {
        event.preventDefault();  // Prevent the default action associated with these key combinations
      }
    };

    const isTouchDevice = "ontouchstart" in document.documentElement;

    if (!isTouchDevice) {
      // Attach the event listeners only for non-touch devices
      document.addEventListener("contextmenu", disableRightClick);
      document.addEventListener("keydown", disableF12);
    }

    // Cleanup event listeners when the component unmounts
    return () => {
      if (!isTouchDevice) {
        document.removeEventListener("contextmenu", disableRightClick);
        document.removeEventListener("keydown", disableF12);
      }
    };
  }, []);
  
  return (
    <LoginProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/Onlineorder" element={<Onlineorder />} />
          <Route path="/Onlineorder1" element={<Onlineorder1 />} />
          {/* Sidebar as layout with nested routes */}
          <Route path="/Sidebar" element={<Sidebar />}>
            <Route path="Dashboard" element={<Dashboard />} />
            <Route path="Dashboard_user" element={<Dasboard_user />} />
            <Route path="Managelead" element={<Managelead />} />
            <Route path="Addlead" element={<Addlead />} />
            <Route path="Distribution" element={<Distribution />} />
            <Route path="Lead_head" element={<Lead_head />} />
            <Route path="Leadtran" element={<Leadtran />} />
            <Route path="WS" element={<Sharecreate />} />
            <Route path="DK" element={<Demokey />} />
            <Route path="Apk" element={<Apk />} />
            <Route path="Reportsview" element={<Reportsview />} />
            <Route path="Reportable" element={<Reportable />} />
            <Route path="Autoshare" element={<Autosend />} />
            <Route path="BWS" element={<Bulkwhatsappsender />} />
            <Route path="Training" element={<Training />} />
            {/* Add more nested routes here if needed */}
            {/* 404 for any unmatched nested route inside Sidebar */}
            <Route path="*" element={<Error />} />
          </Route>
          {/* 404 for any unmatched route outside Sidebar */}
          <Route path="*" element={<Error />} />
        </Routes>
      </Router>
    </LoginProvider>
  );
}

export default App;
